"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCalendarDropdown = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("../../../assets/styles/config");
exports.StyledCalendarDropdown = styled_components_1.default.div `
  align-items: center;
  background: ${config_1.colors.white};
  border: 1px solid ${config_1.colors.huron};
  border-radius: 4px;
  display: flex;
  font: ${config_1.fontSizes.small} ${config_1.fontFamilies.primary};
  height: 45px;
  justify-content: space-between;
  margin-right: 20px;
  padding: 0 15px;
  pointer-events: none;
  position: relative;
  z-index: 2;
`;
